export type TUserNotifications = {
  notifications: TUserNotification[];
};

export enum EUserNotificationType {
  ActionCenter = 'ActionCenter',
  Banner = 'Banner',
  Notification = 'Notification',
  SplashScreen = 'SplashScreen',
}

export enum EUserNotificationLevel {
  Information = 'Information',
  Warning = 'Warning',
  Error = 'Error',
  Alert = 'Alert',
}

export enum EUserNotificationStatus {
  Active = 'Active',
  Expired = 'Expired',
}

export type TUserNotificationResponse = {
  notifications: TUserNotification[];
};

export type TSharePointMedia = {
  teamName: string;
  uniqueId: string;
};

export type TUserNotification = {
  notificationReferenceId: string;
  message?: string;
  notificationName?: string;
  notificationType?: EUserNotificationType;
  notificationLevel?: EUserNotificationLevel;
  richMessage?: string;
  notificationStartDate?: string;
  notificationEndDate?: string;
  notificationStatus?: EUserNotificationStatus;
  title?: string;
  splashEndDate?: string;
  sharePointMedia?: TSharePointMedia;
};

export type TCustomNotificationResponse = {
  notifications: TCustomNotification[];
};

export type TCommonEntity = {
  id: string;
  label: string;
};

export enum ECustomNotificationStatus {
  Active = 'Active',
  Expired = 'Expired',
  Draft = 'Draft',
  Scheduled = 'Scheduled',
}

export type TCustomNotification = {
  id?: string;
  notificationName?: string;
  notificationMessage?: string;
  notificationStartDateTime?: string;
  notificationEndDateTime?: string;
  notificationType?: EUserNotificationType;
  notificationLevel?: EUserNotificationLevel;
  createdDateTime?: string;
  modifiedDateTime?: string;
  isPublished?: boolean;
  publicationDateTime?: string;
  createdBy?: string;
  modifiedBy?: string;
  listOfAlias?: string[];
  businessSegments?: TCommonEntity[];
  countries?: TCommonEntity[];
  qualifier1?: TCommonEntity[];
  qualifier2?: TCommonEntity[];
  userRoles?: TCommonEntity[];
  plans?: TCommonEntity[];
  standardTitles?: TCommonEntity[];
  title?: string;
  splashEndDate?: string;
  sharePointMedia?: TSharePointMedia;
};

export enum EMetadataType {
  BusinessSegments = 'businessSegments',
  Plans = 'plans',
  StandardTitles = 'standardTitles',
  Countries = 'countries',
  Qualifier1 = 'qualifier1',
  Qualifier2 = 'qualifier2',
  UserRoles = 'userRoles',
}

export type NotificationMetadata = {
  metadataType: EMetadataType;
  fiscalYear: string;
  metadataValue: TCommonEntity[];
};

export type TNotificationMetadataResponse = NotificationMetadata[];
